import { observer } from "mobx-react-lite"
import "./about.css"
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const CustomAccess = observer(() => {
    const { t } = useTranslation();
    
    return (
        <div>
                <h1> <span className="rubik">{t("CUSTOM")}</span> <span className="blue-text">{t("ACCESS")}</span></h1>
            <div className="row">
                <div className="features-description">{t("Show the right things to the right people.")}</div>
                <Flex justify="center">
                    <div className="features-image">
                        <img src={`/assets/about/tabs/${i18n.language}/custom-access-img.svg`} alt="" />
                    </div>
                    <div className="list-features">
                        <div>{t("🧑‍💼 Role-based access")}</div>
                        <div>{t("🎯 Individual overrides")}</div>
                        <div></div>
                        <div></div>
                        <div>{t("🗂️ Project-level visibility")}</div>
                        <div>{t("🛡️ Data control for sensitive info")}</div>
                    </div>
                </Flex>
                <p className="features-description-center">{t("Set permissions per role, project, or even individual. Everyone sees only what they need.")}</p>
                <div className="blue-hr"></div>
            </div>
        </div>
    )
})
export default CustomAccess;